import { z } from "zod";

export const categoryAttributeValueSchema = z.object({
  id: z.number().int(),
  value: z.string(),
  order: z.number().int(),
});

export const categoryAttributeResponseSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  values: z.array(categoryAttributeValueSchema),
  categories: z.array(z.string()),
});

export const createCategoryAttributeValueRequestSchema = z.object({
  value: z.string().min(1, "Value is required"),
  order: z.number().int().min(0),
});

export const createCategoryAttributeRequestSchema = z.object({
  name: z.string().min(1, "Name is required"),
  values: z
    .array(createCategoryAttributeValueRequestSchema)
    .min(1, "At least one value is required"),
});

